class CustomScrollyVideo extends ScrollyVideo {
  constructor (params) {
    super(params);
    this.container = params.scrollyVideoContainer;
    this.blocks = this.container.querySelectorAll('[data-period]');
    this.getScrollHandler = this.getScroll.bind(this);
    this._calculatePositionHandler = this._calculatePosition.bind(this);
    this._detectDirectionHandler = this.detectDirection.bind(this);
    this.lastScrollTop = 0;
    this._observer();
    this.startEvent = new CustomEvent('startScrolling');
    this.endEvent = new CustomEvent('scrolledToStart');
  }

  _calculatePosition (e) {
    e.stopPropagation();
    const containerBoundingClientRect = this.container.closest('.scrolly-video-wrapper')?.getBoundingClientRect();
    const scrollPercent = -containerBoundingClientRect.top / (containerBoundingClientRect.height - window.innerHeight);
    this.setTargetTimePercent(scrollPercent, true);
  }

  _observer () {
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this._detectDirectionHandler);
          window.addEventListener('scroll', this._calculatePositionHandler);
          window.addEventListener('scroll', this.getScrollHandler);
        } else {
          window.removeEventListener('scroll', this._calculatePositionHandler);
          window.removeEventListener('scroll', this.getScrollHandler);
          window.removeEventListener('scroll', this._detectDirectionHandler);
        }

      });
    }, {
      threshold: 0.5,
    });
    videoObserver.observe(this.container);
  }

detectDirection () {
    let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollTop <= this.lastScrollTop) {
      if (this.targetTime <= 0) {
        this.container.dispatchEvent(this.endEvent);
      }else if(this.targetTime <= (this.video.duration - 0.08)) {
        this.container.dispatchEvent(this.startEvent);
      }
    }else{
      if(this.targetTime >= (this.video.duration - 0.1)) {
        this.container.dispatchEvent(this.endEvent);
      }else if(this.targetTime >= 0.1) {
        this.container.dispatchEvent(this.startEvent);
      }
    }
    this.lastScrollTop = currentScrollTop;
  }

/*detectDirection () {
    let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollTop <= this.lastScrollTop) {
      if (this.targetTime <= 0) {
        this.container.dispatchEvent(this.endEvent);
      }else if(this.targetTime <= (this.video.duration - 0.02)) {
        this.container.dispatchEvent(this.startEvent);
      }
    }else{
      if(this.targetTime === this.video.duration) {
        this.container.dispatchEvent(this.endEvent);
      }else if(this.targetTime >= 0.02) {
        this.container.dispatchEvent(this.startEvent);
      }
    }
    this.lastScrollTop = currentScrollTop;
  }*/

  getScroll (e) {
    e.stopPropagation();
    this.blocks.forEach(block => {
      const period = Shopify.designMode ? 0 : block.getAttribute('data-period');
      const periodEnd = Shopify.designMode ? 1000000 : block.getAttribute('data-period-end');
      if (Number(period) <= this.targetTime && Number(periodEnd) >= this.targetTime) {
        block.classList.add('animated');
      } else {
        block.classList.remove('animated');
      }
    });
  }

  destroy () {
    super.destroy();
  }
}
